import { NavigationContainer } from "@react-navigation/native";
import react from "react";
import { Text, StyleSheet, TouchableOpacity, ScrollView, Image, Linking, SafeAreaView, I18nManager } from "react-native";
import { View, Dimensions } from "react-native";
import Icon from 'react-native-vector-icons/FontAwesome';
import { useTranslation } from 'react-i18next';
import { i18n } from '../assets/lang/i18next';
const MenuNav = props => {
    const { t, i18n } = useTranslation();

    return (
        <ScrollView showsHorizontalScrollIndicator={false} style={{ backgroundColor: '#0b4660' }}>

            <SafeAreaView style={{ backgroundColor: '#0b4660', flex: 1, justifyContent: 'center', padding: 15 }}>

                <Text style={{ fontFamily: 'IranSans', fontSize: 14.5, fontWeight: 100, margin: 20, color: 'white', marginTop: 50 }}>
                    {t('aboutdescription1')}
                </Text>

                <Text style={{ fontFamily: 'IranSans', fontSize: 14.5, fontWeight: 100, margin: 20, color: 'white' }}>
                    {t('aboutdescription2')}
                </Text>

                <View style={{ flexDirection: 'row', justifyContent: 'space-between', margin: 10 }}>
                    <TouchableOpacity onPress={() => Linking.openURL("https://arshehkar.com/")} style={styles.touchable}>
                        <Image source={require('../assets/icons/web-icon.png')} style={{ width: 35, height: 35 }} resizeMode="contain" />
                        <Text style={styles.title}>{t('website')}</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.touchable} onPress={() => Linking.openURL("tel:02189355")}>
                        <Icon name={'phone'} size={24} color={"white"} />
                        <Text style={styles.title}>{t('contactus')}</Text>
                    </TouchableOpacity>

                </View>

                <View style={{ flexDirection: 'row', justifyContent: 'space-between', margin: 10 }}>
                    <TouchableOpacity onPress={() => i18n.changeLanguage("en")} style={styles.touchable}>
                        <Image source={require('../assets/enbtn.png')} style={{ width: 50, height: 45 }} resizeMode="contain" />
                        <Text style={styles.title}>{t('English')}</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.touchable} onPress={() => i18n.changeLanguage("fa")}>
                        <Image source={require('../assets/fabtn.png')} style={{ width: 50, height: 45 }} resizeMode="contain" />
                        <Text style={styles.title}>{t('Persian')}</Text>
                    </TouchableOpacity>

                </View>


            </SafeAreaView>

        </ScrollView>
    )
}
const styles = StyleSheet.create(
    {

        listRow: {
            height: 50,
            width: '100%',
            padding: 10,
            paddingRight: 33,
            marginRight: 10,
            marginLeft: 3,
            backgroundColor: '#ebede7',
            color: '#fff',
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 0.5 },
            shadowOpacity: 0.7,
            shadowRadius: 2,
            justifyContent: 'center',
            borderRadius: 50,
            marginBottom: 10,

        }
        , listRowdd: {
            height: 50,
            width: '100%',
            padding: 10,
            paddingRight: 33,
            margin: 0,
            backgroundColor: '#ebede7',
            color: '#fff',
            borderRadius: 3,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 0.5 },
            shadowOpacity: 0.7,
            shadowRadius: 2,
            justifyContent: 'center',
            borderBottomRightRadius: 50,
            borderTopRightRadius: 50,
            marginBottom: 10,
            borderBottomRightRadius: 25,
            borderTopRightRadius: 25,
            writingDirection: I18nManager.isRTL ? 'rtl' : 'ltr'
        }
        ,
        title: {
            paddingRight: 15,
            padding: 17,
            fontFamily: 'IranSans',
            fontSize: 14,
            textAlignVertical: 'middle',
            color: '#fff'
        }
        ,
        img: {
            width: 100,
            height: 85,
            borderRadius: 3,
            resizeMode: 'cover',

        }
        , touchable: {
            justifyContent: 'center',
            alignItems: 'center',
            flex: 1, flexDirection: 'row',
            backgroundColor: '#0b3756', margin: 5,
        }
    }
)
export default MenuNav;